import { DARK } from '@core/constants/theme';
import { styled } from '@ublend-npm/aulaui-core';

export const Container = styled('div')`
  position: relative;
  height: 24px;
  padding-bottom: 8px;
  margin-left: 16px;
  margin-right: 16px;
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const LabelContainer = styled('p')`
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  text-align: start;
  margin: 0;
  margin-left: 11px;
`;

export const Label = styled('span')(({ theme }) => ({
  fontSize: '0.875rem',
  letterSpacing: '0.17px',
  lineHeight: '143%',
  backgroundColor: 'transparent',
  fontFamily: 'Roboto, sans-serif',
  padding: 0,
  color:
    theme.palette.mode === DARK
      ? 'rgba(255, 255, 255, 0.7)'
      : 'rgba(0, 0, 0, 0.6)',
}));
